// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1PLrJ","boxTitle":"Qualiphy_boxTitle__jZU7s","box":"Qualiphy_box__2_0zv","toggleWrap":"Qualiphy_toggleWrap__1o65A"};